import configService from "@app/config/ConfigService";

// craco injects VERSION as `<package.json version> @ <build date> @ <tz>`.
const getAppVersionInfo = (): { buildDate: string; version: string } => {
  const [version, buildDate] = configService.getVersion().split(/\s*@\s*/);
  return { buildDate, version };
};

export default getAppVersionInfo;
